<template>
  <templateAdminComponent v-if="isUserAuthenticated()">
    <div v-if="isUserAuthenticated()">
      <v-toolbar flat color="white">
        <v-toolbar-title>Évènements</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px" no-click-animation persistent>
          <v-btn slot="activator" color="primary" dark class="mb-2" @click="createItem()">Nouvel évènement</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-menu
                      :close-on-content-click="false"
                      v-model="menu"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="editedItem.Date"
                        label="Date"
                        persistent-hint
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" no-title @input="saveDate(editedItem, date)"></v-date-picker>
                      <v-time-picker v-model="time" format="24hr" @input="saveTime(editedItem, time)"></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-textarea v-model="editedItem.Description" label="Description" rows="6" hide-details></v-textarea>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox v-model="editedItem.IsActive" label="Est actif"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-checkbox v-model="editedItem.IsCustomerEventSent" label="Envoi de courriels complété"></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="close">Annuler</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save">Sauvegarder</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          hide-actions
          class="elevation-1"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable', 
                  pagination.descending ? 'desc' : 'asc', 
                  header.value === pagination.sortBy ? 'active' : '',
                  header.align ? 'text-xs-' + header.align : ''
                ]"
                :width="header.width"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.Date | formatDateTime }}</td>
            <td class="text-xs-left">{{ props.item.Description }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                medium
                class="mr-2"
                @click="editItem(props.item)"
              >
                edit
              </v-icon>
              <!-- <v-icon
                small
                @click="deleteItem(props.item)"
              >
                delete
              </v-icon> -->
            </td>
          </template>
          <template slot="no-data">
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <!-- <v-pagination v-model="pagination.page" :length="pages"></v-pagination> -->
          <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-card>
    </div>
  </templateAdminComponent>
</template>

<script>
import moment from 'moment'
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import APIEvent from '@/api/event'
const APIService = new APIEvent();

var axios = require('axios')

export default {
  components:
  {
    TemplateAdminComponent
  },
  data() {
    return {
        date: null,
        time: null,
        menu: false,
        modal: false,

        dialog: false,
        loading: false,
        pagination: {
          sortBy: 'Name',
          page: 1,
          rowsPerPage: 10
        },
        headers : [
          { text: 'Date', value: 'Date', align: 'left' },
          { text: 'Description', value: 'Description', align: 'left', width: '75%' },
          { text: 'Actions', value: 'Actions', align: 'center', sortable: false }
        ],
        items: [],
        editedIndex: -1,
        editedItem: {},
        defaultItem: {
          Date: moment().format("YYYY-MM-DD HH:mm"),
          IsCustomerEventSent: true,
          IsActive: true
        }
    }
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nouvel événement' : 'Modification de l\'événement'
    },

    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null)
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    items () {
      this.$nextTick(() => {
        this.pagination.totalItems = this.items.length
      })
    }
  },

  created(){
    this.initialize()
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    logout() {
      auth.logout()
    },

    initialize () {
      var events = APIService.getAll().then(response =>  {
            this.items = response.data
        }
      )

    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    
    createItem () {
      //debugger;
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.date = moment().format("YYYY-MM-DD")
      this.time = moment().format("HH:mm")
      this.dialog = true
    },
    
    editItem (item) {
      //debugger;
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.Date = moment(this.editedItem.Date).format("YYYY-MM-DD HH:mm")
      this.date = moment(this.editedItem.Date).format("YYYY-MM-DD")
      this.time = moment(this.editedItem.Date).format("HH:mm")
      this.dialog = true
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        //UPDATE
        APIService.update(this.editedItem).then(response => {
          //debugger;
          if(response.data)
          {
            if (this.editedItem.IsActive)
            {
              Object.assign(this.items[this.editedIndex], this.editedItem)
            }
            else
            {
              this.items.splice(this.editedIndex, 1)
            }
          }
          this.close()
        })
      } else {
        //CREATE
        APIService.create(this.editedItem).then(response => {
          //debugger;
          if(response.data)
            this.items.unshift(response.data)

          this.close()
        })
      }
    },

    saveDate(item, date) {
      //alert(date)
      //item.Date = date
      if (this.date != null && this.time != null)
      {
        item.Date = moment(date + " " + this.time).format('YYYY-MM-DD HH:mm')
        this.menu = false
        
      }
      this.dialog = true
    },

    saveTime(item, time) {
      //alert(time)
      if (this.date != null && this.time != null)
      {
        debugger
        item.Date = moment(this.date + " " + time).format('YYYY-MM-DD HH:mm')
        this.menu = false
        
      }
      this.dialog = true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/admin/Evenements.vue